module.exports = __webpack_public_path__ + "static/media/gryphon_brent_comber.9b2e280e.jpg";